import { css } from '@emotion/react';
import { zIndex } from 'shared/config';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.channel-filter': {
    '&__click-component': {
      margin: theme.space[3],
      minWidth: '185px',
      borderBottom: `1px solid ${COLORS.NEUTRAL500}`,
      color: COLORS.NEUTRAL500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 5px',
      height: '34px',
      fontSize: '14px',
    },
    '&__click-component--active': {
      color: COLORS.PRIMARY500,
    },
    '&__click-component[data-state="open"] .dropdown-field__click-icon': {
      transform: 'rotate(180deg)',
      marginTop: '7px',
    },
    '&__filter-label': {
      fontWeight: 600,
      padding: theme.space[4],
      cursor: 'default',
      marginBottom: 0,
    },
    '&__filter-label:hover': {
      backgroundColor: COLORS.WHITE,
    },
    '&__submenu-wrapper': {
      overflow: 'hidden',
      maxHeight: '450px',
    },
    '&__submenu-wrapper:hover': {
      backgroundColor: COLORS.WHITE,
    },
    '&__submenu-buttons': {
      justifyContent: 'flex-end',
      gap: theme.space[2],
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: COLORS.WHITE,
      padding: `${theme.space[4]} ${theme.space[4]}`,
    },
    '&__button': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  '.channel-filter': {
    '&__submenu-scroll-area': {
      height: '100%',
      maxHeight: '400px',
      overflowY: 'auto',
      padding: theme.space[4],
      paddingBottom: '60px',
    },
    '&__filter-label': {
      fontWeight: 600,
      padding: `${theme.space[4]} 0 0 0`,
      cursor: 'default',
      marginBottom: theme.space[4],
    },
    '&__filter-label:hover': {
      backgroundColor: COLORS.WHITE,
    },
    '&__filter-icon': {
      marginRight: theme.space[2],
    },
    '&__filter-name': {
      marginBottom: 0,
      display: 'flex',
      alignItems: 'center',
      padding: theme.space[4],
    },
  },
});

export const searchBarStyles = css({
  '&.channel-filter': {
    '&__search-bar': {
      position: 'relative',
      alignItems: 'center',
      flexGrow: 1,
      width: `calc(100% - 2 * ${theme.space[4]})`,
      margin: theme.space[4],
    },
  },
  '.channel-filter': {
    '&__icon': {
      position: 'absolute',
      left: '10px',
      zIndex: zIndex.zForeground,
      top: '10px',
      margin: 0,
    },
    '&__spinner': {
      position: 'absolute',
      right: '10px',
      zIndex: zIndex.zForeground,
      top: '12px',
      color: COLORS.NEUTRAL700,
    },
    '&__search-input': {
      width: '100%',
      margin: 0,
      flexGrow: 1,
      '& input': {
        paddingLeft: '40px',
        margin: 0,
        borderRadius: '20px',
      },
    },
  },
});
